import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { routingProfileServiceEnvironment } from '../routing-profile-service-environment';

/**
 * Delete an existing Routing Profile by its ID
 * @param routingProfileId ID of the Routing Profile
 * @returns A Data object indicating success
 */
export function deleteRoutingProfilesId(
  this: unknown,
  routingProfileId: number
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          routingProfileServiceEnvironment.resolve(this).routingProfilesUrl
        }/${encodeURIComponent(routingProfileId)}`,
        {
          method: 'DELETE',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        message: z.string(),
        data: z.boolean(),
      })
    )
  );
}
